import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/shared/shared.module';
import { BaseKnowledgeCatalogComponent } from './base-knowledge-catalog.component';
import { BaseKnowledgeCatalogService } from './services/base-knowledge-catalog.service';
import { BaseKnowledgeCatalogStaticComponent } from './base-knowledge-catalog-static/base-knowledge-catalog-static.component';
import { BaseKnowledgeCatalogLearnedComponent } from './base-knowledge-catalog-learned/base-knowledge-catalog-learned.component';
import { AddArtifactModalComponent } from './add-artifact-modal/add-artifact-modal';
import { FileArtifactsTableComponent } from './components/file-artifacts-table/file-artifacts-table.component';
import { BaseKnowledgeCatalogBizagiDataComponent } from './base-knowledge-catalog-bizagi-data/base-knowledge-catalog-bizagi-data.component';
import { CategoriesBizagiDataComponent } from './base-knowledge-catalog-bizagi-data/categories-bizagi-data/categories-bizagi-data.component';
import { BizagiDataDetailComponent } from './base-knowledge-catalog-bizagi-data/bizagi-data-detail/bizagi-data-detail.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}

@NgModule({
  declarations: [
    BaseKnowledgeCatalogComponent,
    BaseKnowledgeCatalogLearnedComponent,
    BaseKnowledgeCatalogStaticComponent,
    AddArtifactModalComponent,
    FileArtifactsTableComponent,
    BaseKnowledgeCatalogBizagiDataComponent,
    CategoriesBizagiDataComponent,
    BizagiDataDetailComponent
  ],
  imports: [
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ],
  exports: [
    BaseKnowledgeCatalogComponent
  ],
  providers: [
    BaseKnowledgeCatalogService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class BaseKnowledgeCatalogModule { }
